export const GET_PRESIGNED_URL_START = 'Upload/GET_PRESIGNED_URL_START';
export const GET_PRESIGNED_URL_SUCCESS= 'Upload/GET_PRESIGNED_URL_SUCCESS';
export const GET_PRESIGNED_URL_FAILURE= 'Upload/GET_PRESIGNED_URL_FAILURE';

export const UPLOAD_FILE_START = 'Upload/UPLOAD_FILE_START';
export const UPLOAD_FILE_SUCCESS= 'Upload/UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE= 'Upload/UPLOAD_FILE_FAILURE';
